import { connect } from 'react-redux'

import TabTaskList from './units'

const mapStateToProps = state => ({
  taskStatus: state.RunProject.allData.rows.tasksStatus[0],
  taskData: state.TaskList.taskData,
  allData: state.RunProject.allData,
  taskStatusList: state.Reference.statusDefinition.task,
})

export default connect(mapStateToProps)(TabTaskList)
